import { render, staticRenderFns } from "./confirmSms.vue?vue&type=template&id=498760fa&scoped=true"
import script from "./confirmSms.vue?vue&type=script&lang=js"
export * from "./confirmSms.vue?vue&type=script&lang=js"
import style0 from "./confirmSms.vue?vue&type=style&index=0&id=498760fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498760fa",
  null
  
)

export default component.exports